import eventService from "..";
import { AppEvent } from "../constants";
import { appConfigService } from "services/appConfigService";
import moment from "moment";

eventService.addListener(AppEvent.CHANGE_LANGUAGE, (lang: "vi" | "en") => {
  appConfigService.setItem("lang", lang);
  // window.location.reload();
  if (lang === "vi") {
    require("moment/locale/vi");
  } else {
    require("moment/locale/en-gb");
  }
  moment.locale(lang);
});
